import React, { useEffect, useState } from 'react';
import { fmtNumber } from '../../shared/format';

// Shared client-side paging for the client-page list cards (contacts, requests,
// threads) so a card with many rows stays manageable instead of an endless
// scroll. 25 per page; the pager hides itself when there is only one page.
export const PANEL_PAGE_SIZE = 25;

// `resetKey` (e.g. the clientId) re-seats page 1 when the population is swapped
// out under the pager, not just when its length changes.
export function usePaged(rows, resetKey, pageSize = PANEL_PAGE_SIZE) {
  const [page, setPage] = useState(1);
  useEffect(() => { setPage(1); }, [resetKey, rows.length]);
  const pageCount = Math.max(1, Math.ceil(rows.length / pageSize));
  const current = Math.min(page, pageCount);
  const pageRows = rows.slice((current - 1) * pageSize, current * pageSize);
  return { pageRows, page: current, setPage, pageCount, pageSize, total: rows.length };
}

const BTN =
  'rounded-lg border border-gray-200 bg-white px-2.5 py-1 text-xs text-gray-700 disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-300';

export function Pager({ page, pageCount, pageSize, total, onPage }) {
  if (pageCount <= 1) return null;
  return (
    <nav className="flex items-center justify-between gap-3 border-t border-gray-100 pt-3 dark:border-gray-800" aria-label="Pagination">
      <span className="text-xs tabular-nums text-gray-400">
        {fmtNumber((page - 1) * pageSize + 1)}–{fmtNumber(Math.min(page * pageSize, total))} of {fmtNumber(total)}
      </span>
      <div className="inline-flex items-center gap-2">
        <button type="button" className={BTN} onClick={() => onPage(Math.max(1, page - 1))} disabled={page <= 1}>
          Previous
        </button>
        <span className="text-xs tabular-nums text-gray-400">
          Page {fmtNumber(page)} of {fmtNumber(pageCount)}
        </span>
        <button type="button" className={BTN} onClick={() => onPage(Math.min(pageCount, page + 1))} disabled={page >= pageCount}>
          Next
        </button>
      </div>
    </nav>
  );
}
